import css from "./AuthForm.module.css";

import { useState } from "react";
import { Input } from "./Input";
import { Button } from "../ui/Button";
import { useRealm } from "~/util/Lang";
import { callApi } from "~/util/Loaders";
import { useNavigate } from "react-router";
import { LinkDiscordButton } from "../site/links/LinkDiscordButton";
import dayjs from "dayjs";
import { authRegisterApi } from "~/routes/__site/api/auth/register.pages";

export function RegisterForm(props: { redirectUrl: string | null }) {
  const [login, setLogin] = useState("");
  const [pswd, setPswd] = useState("");
  const [pswd2, setPswd2] = useState("");
  const [email, setEmail] = useState("");
  const timezone = dayjs.tz.guess();
  const [errors, setErrors] = useState<{
    login?: string;
    pswd?: string;
    pswd2?: string;
    email?: string;
  }>({});
  const [error, setError] = useState<null | string>();
  const [loading, setLoading] = useState(false);
  const realm = useRealm();
  const nav = useNavigate();
  return (
    <div className={css.root}>
      <div className={css.wrapper}>
        <h2>Register</h2>
        {error && <div className={css.warning}>{error}</div>}
        <form
          className={css.form}
          onSubmit={async (e) => {
            e.preventDefault();
            const newErrors: typeof errors = {};

            if (!login.trim()) newErrors.login = "Login is required.";
            if (!pswd.trim()) newErrors.pswd = "Password is required.";
            if (!pswd.trim()) newErrors.pswd2 = "Password is required.";
            if (!pswd.trim()) newErrors.email = "Email is required.";
            if (pswd.trim() !== pswd2.trim())
              newErrors.pswd2 = "Passwords do not match.";

            if (Object.keys(newErrors).length > 0) {
              setErrors(newErrors);
              return;
            }

            // Если валидация прошла
            setErrors({});

            setLoading(true);

            const result = await callApi(authRegisterApi, {
              input: { login, pswd, email, timezone },
              realm,
              method: "POST",
            });

            setLoading(false);

            switch (result.t) {
              case "success":
                return props.redirectUrl
                  ? nav(props.redirectUrl)
                  : nav("/profile");
              case "error":
                return setError(result.error);
            }

            // if (res.t === "error" && res.field === "login") {
            //   setErrors({ login: res.message });
            // }
          }}
        >
          <Input
            label="Login"
            value={login}
            onChange={(e) => {
              setErrors((prevErrors) => {
                const { login, ...rest } = prevErrors;
                return rest;
              });
              setLogin(e.target.value);
            }}
            autoFocus
            required={true}
            error={errors.login}
            hasGlobalError={!!error}
            type="text"
          />
          <Input
            label="Password"
            value={pswd}
            onChange={(e) => {
              setErrors((prevErrors) => {
                const { pswd, ...rest } = prevErrors;
                return rest;
              });
              setPswd(e.target.value);
            }}
            autoFocus
            required={true}
            error={errors.pswd}
            hasGlobalError={!!error}
            type="password"
          />
          <Input
            label="Password again"
            value={pswd2}
            onChange={(e) => {
              setErrors((prevErrors) => {
                const { pswd2, ...rest } = prevErrors;
                return rest;
              });
              setPswd2(e.target.value);
            }}
            autoFocus
            required={true}
            error={errors.pswd2}
            hasGlobalError={!!error}
            type="password"
          />
          <Input
            label="E-Mail"
            value={email}
            onChange={(e) => {
              setErrors((prevErrors) => {
                const { email, ...rest } = prevErrors;
                return rest;
              });
              setEmail(e.target.value);
            }}
            autoFocus
            required={true}
            error={errors.email}
            hasGlobalError={!!error}
            type="text"
          />
          <Button type="submit" disabled={loading}>
            {loading ? "Loading..." : "Register"}
          </Button>
        </form>
        <div className={css.line}>
          <hr />
          <span>OR</span>
        </div>
        <div className={css.discord}>
          <LinkDiscordButton disabled={loading}>
            Continue with Discord
          </LinkDiscordButton>
        </div>
      </div>
    </div>
  );
}
